import { RouteComparison } from "@/features/treasury/treasury";

export default function TreasuryRoutesPage() {
  return <RouteComparison />;
}
